import { render, staticRenderFns } from "./RightSideKefu.vue?vue&type=template&id=10221b0a&scoped=true&"
import script from "./RightSideKefu.vue?vue&type=script&lang=js&"
export * from "./RightSideKefu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10221b0a",
  null
  
)

export default component.exports